import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tabsDefaultVariants = {
  "align": "left"
}
const tabsCompoundVariants = []

const tabsSlotNames = [
  [
    "root",
    "Tabs__root"
  ],
  [
    "wrapper",
    "Tabs__wrapper"
  ],
  [
    "scrollContainer",
    "Tabs__scrollContainer"
  ],
  [
    "scrollButton",
    "Tabs__scrollButton"
  ],
  [
    "scrollButtonBackward",
    "Tabs__scrollButtonBackward"
  ],
  [
    "scrollButtonForward",
    "Tabs__scrollButtonForward"
  ],
  [
    "tablist",
    "Tabs__tablist"
  ],
  [
    "pane",
    "Tabs__pane"
  ]
]
const tabsSlotFns = /* @__PURE__ */ tabsSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tabsDefaultVariants, getSlotCompoundVariant(tabsCompoundVariants, slotName))])

const tabsFn = memo((props = {}) => {
  return Object.fromEntries(tabsSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tabsVariantKeys = [
  "align"
]
const getVariantProps = (variants) => ({ ...tabsDefaultVariants, ...compact(variants) })

export const tabs = /* @__PURE__ */ Object.assign(tabsFn, {
  __recipe__: false,
  __name__: 'tabs',
  raw: (props) => props,
  variantKeys: tabsVariantKeys,
  variantMap: {
  "align": [
    "left",
    "right",
    "center"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, tabsVariantKeys)
  },
  getVariantProps
})